/* ==========================================================================
   region.js — Ontario / Federal region selector for Royale Holding Shopify store
   --------------------------------------------------------------------------
   Drop into your theme's /assets/ folder and reference from theme.liquid:
       <script src="{{ 'region.js' | asset_url }}" defer></script>
       <link rel="stylesheet" href="{{ 'region.css' | asset_url }}">

   Storage key:  localStorage["royale_region"] = "on" | "fe"
   ========================================================================== */
(function () {
  'use strict';

  var STORAGE_KEY = 'royale_region';
  var REGIONS = {
    on: { label: 'Ontario', flag: '🍁' },
    fe: { label: 'Federal', flag: '🇨🇦' }
  };

  function getRegion() {
    try {
      var v = (localStorage.getItem(STORAGE_KEY) || '').toLowerCase();
      return REGIONS[v] ? v : null;
    } catch (e) {
      return null;
    }
  }

  function setRegion(region) {
    if (!REGIONS[region]) return;
    try {
      localStorage.setItem(STORAGE_KEY, region);
    } catch (e) {
      /* localStorage disabled — fall through, modal will reappear next visit */
    }
    document.documentElement.setAttribute('data-royale-region', region);
  }

  /* ----------------------- Modal (first-visit gate) ----------------------- */
  function initModal() {
    var modal = document.getElementById('royale-region-modal');
    if (!modal) return;

    if (getRegion()) {
      // Already chosen; never show.
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      return;
    }

    modal.hidden = false;
    modal.removeAttribute('aria-hidden');
    document.body.classList.add('royale-region-modal-open');

    var buttons = modal.querySelectorAll('[data-region]');
    Array.prototype.forEach.call(buttons, function (btn) {
      btn.addEventListener('click', function () {
        var region = btn.getAttribute('data-region');
        if (!REGIONS[region]) return;
        setRegion(region);
        modal.hidden = true;
        document.body.classList.remove('royale-region-modal-open');
        // Reload so collection pages re-filter and product guards re-evaluate.
        window.location.reload();
      });
    });
  }

  /* ----------------------- Header switcher ----------------------- */
  function initSwitcher() {
    var roots = document.querySelectorAll('[data-royale-region-switcher]');
    if (!roots.length) return;

    Array.prototype.forEach.call(roots, function (root) {
      var toggle = root.querySelector('[data-royale-region-toggle]');
      var menu = root.querySelector('[data-royale-region-menu]');
      var labelEl = root.querySelector('[data-royale-region-label]');
      var flagEl = root.querySelector('[data-royale-region-flag]');
      var items = root.querySelectorAll('[data-region]');

      // Sync label to current region. If unset, show a neutral placeholder so
      // we don't pretend a region was chosen before the modal is resolved.
      function syncLabel() {
        var current = getRegion();
        if (current && REGIONS[current]) {
          if (labelEl) labelEl.textContent = REGIONS[current].label;
          if (flagEl) flagEl.textContent = REGIONS[current].flag;
        } else {
          if (labelEl) labelEl.textContent = 'Select region';
          if (flagEl) flagEl.textContent = '🍁';
        }
      }
      syncLabel();

      toggle.addEventListener('click', function () {
        var open = !menu.hidden;
        menu.hidden = open;
        toggle.setAttribute('aria-expanded', String(!open));
      });

      // Close on outside click
      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) {
          menu.hidden = true;
          toggle.setAttribute('aria-expanded', 'false');
        }
      });

      // Close on Escape
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          menu.hidden = true;
          toggle.setAttribute('aria-expanded', 'false');
        }
      });

      Array.prototype.forEach.call(items, function (item) {
        item.addEventListener('click', function () {
          var region = item.getAttribute('data-region');
          if (!REGIONS[region]) return;
          setRegion(region);
          // Strip any existing region tag filter from URL so the collection
          // filter snippet picks up the new region cleanly.
          try {
            var url = new URL(window.location.href);
            var kept = url.searchParams.getAll('filter.p.tag').filter(function (t) {
              var lt = (t || '').toLowerCase();
              return lt !== 'region:on' && lt !== 'region:fe' && lt !== 'region:any';
            });
            url.searchParams.delete('filter.p.tag');
            kept.forEach(function (t) { url.searchParams.append('filter.p.tag', t); });
            window.location.assign(url.toString());
          } catch (e) {
            window.location.reload();
          }
        });
      });
    });
  }

  /* ----------------------- Product page guard ----------------------- */
  function initProductGuard() {
    var guard = document.querySelector('[data-royale-region-guard]');
    if (!guard) return;

    var productRegion = (guard.getAttribute('data-product-region') || 'any').toLowerCase();
    var userRegion = getRegion();

    // Region-agnostic products: never guard.
    if (productRegion === 'any') {
      guard.hidden = true;
      return;
    }
    // No region picked yet (modal is showing): don't guard, modal will reload.
    if (!userRegion) {
      guard.hidden = true;
      return;
    }
    // Match: don't guard.
    if (userRegion === productRegion) {
      guard.hidden = true;
      return;
    }

    // Mismatch: show the guard, populate the swap target.
    var otherRegion = productRegion;
    var otherLabel = REGIONS[otherRegion] ? REGIONS[otherRegion].label : otherRegion.toUpperCase();
    var regionLabelEls = guard.querySelectorAll('[data-royale-region-guard-region]');
    Array.prototype.forEach.call(regionLabelEls, function (el) { el.textContent = otherLabel; });

    var switchLabelEls = guard.querySelectorAll('[data-royale-region-guard-switch-label]');
    Array.prototype.forEach.call(switchLabelEls, function (el) { el.textContent = otherLabel; });

    var switchBtn = guard.querySelector('[data-royale-region-guard-switch]');
    if (switchBtn) {
      switchBtn.addEventListener('click', function () {
        setRegion(otherRegion);
        window.location.reload();
      });
    }

    guard.hidden = false;
    document.body.classList.add('royale-region-guard-active');
  }

  /* ----------------------- Optional geo-IP hint ----------------------- */
  // Disabled by default. Uncomment and supply your own endpoint if desired.
  // function geoHint() {
  //   if (getRegion()) return;
  //   fetch('https://ipapi.co/json/').then(function (r) { return r.json(); }).then(function (d) {
  //     if (!getRegion() && d && d.region === 'Ontario') {
  //       // Pre-select Ontario in the modal — user must still click to confirm.
  //       var btn = document.querySelector('#royale-region-modal [data-region="on"]');
  //       if (btn) btn.classList.add('royale-region-modal__choice--suggested');
  //     }
  //   }).catch(function () {});
  // }

  /* ----------------------- Init ----------------------- */
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var current = getRegion();
    if (current) document.documentElement.setAttribute('data-royale-region', current);
    initModal();
    initSwitcher();
    initProductGuard();
    // geoHint();
  });
})();
